import { Component } from '@angular/core';
import { ActivatedRoute } from '@angular/router';
import { JobService } from 'src/app/services/job.service';

@Component({
  selector: 'app-test',
  templateUrl: './test.component.html',
  styleUrls: ['./test.component.scss']
})
export class TestComponent {
  jobs: any[] = [];
  mode: string;

  constructor(private jobService: JobService, private route: ActivatedRoute) {
  }

  async ngOnInit() {
    this.mode = this.route.snapshot.queryParams['mode'];
    switch (this.mode) {
      case 'job':
        const jobres = await this.jobService.search({
          Sort: 2,
          State: 'تهران', 
          Keyword: 'منشی',
          PaidJobsCount: 5,
          AllowSearchFallback: true,
          IncludeQueries: true,
          IncludeRelatedPages: true,
          IncludeSuggestions: true,
          IncludeTopics: true,
          IncludeJobTitles: true,
          IncludeAdvertise: true
        });
        this.jobs = jobres.jobs;
        break;
      case 'api':
      case 'summary':
        const res = await this.jobService.search({ State: 'تهران', Keyword: 'منشی' });
        this.jobs = res.jobs;
      case 'no-api':
        break;
      default:
        return;
    }
  }

}
